import { createSlice } from '@reduxjs/toolkit'

export const NAME = 'hardware-order'

export const HW_ORDER_LIMIT = 4000

export const increaseActiveStepId = () => (dispatch, getState) => {
  const activeStepId = getActiveStepId(getState())
  activeStepId < HARDWARE_ORDER_STEPS.length - 1 && dispatch(setActiveStepId(activeStepId + 1))
}

export const decreaseActiveStepId = () => (dispatch, getState) => {
  const activeStepId = getActiveStepId(getState())
  activeStepId > 0 && dispatch(setActiveStepId(activeStepId - 1))
}

export const HARDWARE_CATEGORY = {
  HOME_OFFICE: 'HOME_OFFICE',
  MOBILE_PHONE: 'MOBILE_PHONE',
  MOBILE_PHONE_ACCESSORY: 'MOBILE_PHONE_ACCESSORY',
  MONITOR: 'MONITOR',
  PC: 'PC',
  PC_ACCESSORY: 'PC_ACCESSORY',
  SHIPPING: 'SHIPPING',
  SOFTWARE: 'SOFTWARE',
  TABLET: 'TABLET',
}

export const HARDWARE_ORDER_STEP = {
  INVENTORY: 'INVENTORY',
  CONFIRMATION: 'CONFIRMATION',
}

export const HARDWARE_ORDER_STEPS = [
  HARDWARE_ORDER_STEP.INVENTORY,
  HARDWARE_ORDER_STEP.CONFIRMATION,
]

const initialState = {
  inventory: [],
  selectedProducts: [],
  oldOrderLines: [],
  activeStepId: 0,
  address: '',
  zip: '',
  city: '',
  orderId: undefined,
  error: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setInventory: (state, { payload: inventory }) => {
      state.inventory = inventory
    },
    setOldOrderLines: (state, { payload: oldOrderLines }) => {
      state.oldOrderLines = oldOrderLines
    },
    selectProduct: (state, { payload: id }) => {
      state.selectedProducts = [...new Set([...state.selectedProducts, id])]
    },
    deselectProduct: (state, { payload: id }) => {
      state.selectedProducts = state.selectedProducts.filter(productId => productId !== id)
    },
    setActiveStepId: (state, { payload: activeStepId }) => {
      state.activeStepId = activeStepId
    },
    setAddress: (state, { payload: address }) => {
      state.address = address
    },
    setZip: (state, { payload: zip }) => {
      state.zip = zip
    },
    setCity: (state, { payload: city }) => {
      state.city = city
    },
    setOrderId: (state, { payload: orderId }) => {
      state.orderId = orderId
    },
    setError: (state, { payload: error }) => {
      state.error = error
    },
    reset: () => ({ ...initialState }),
  },
})

export const {
  setInventory,
  setOldOrderLines,
  selectProduct,
  deselectProduct,
  setActiveStepId,
  setAddress,
  setZip,
  setCity,
  setError,
  setOrderId,
  reset,
} = actions
export default reducer

const getState = state => state[NAME]

export const getOldOrderLines = state => getState(state).oldOrderLines
export const getOldOrderLineSum = state =>
  getOldOrderLines(state).reduce((acc, cur) => acc + cur.amount_sum, 0)

export const getInventory = state => getState(state).inventory
export const getNonShippingInventory = state =>
  getInventory(state).filter(product => product.category !== HARDWARE_CATEGORY.SHIPPING)

export const getProductFromId = (state, id) =>
  getInventory(state).find(product => product.id === id)

export const getSelectedProductIds = state => getState(state).selectedProducts
export const getIsProductSelected = (state, id) =>
  getSelectedProductIds(state).some(productId => productId === id)

export const getSelectedProducts = state =>
  getSelectedProductIds(state).map(productId => getProductFromId(state, productId))

export const getOrderTotalCost = state =>
  getSelectedProducts(state).reduce((acc, cur) => acc + cur.buying_price, 0)

export const isOrderOverLimit = state => getOrderTotalCost(state) > HW_ORDER_LIMIT

export const getActiveStepId = state => getState(state).activeStepId
export const getActiveStep = state => HARDWARE_ORDER_STEPS[getActiveStepId(state)]
export const getIsFirstStep = state => getActiveStepId(state) === 0
export const getIsFinalStep = state => getActiveStepId(state) === HARDWARE_ORDER_STEPS.length - 1

export const getAddress = state => getState(state).address
export const getZip = state => getState(state).zip
export const getCity = state => getState(state).city
export const getIsAddressValid = state =>
  !!getAddress(state) && getZip(state)?.length === 4 && !!getCity(state)

export const getOrderId = state => getState(state).orderId
export const getError = state => getState(state).error

export const getWhatever = true
